<tec-empty-state
    [title]="'OPERATIONS.DETAIL.TABS.CHECKS.EMPTY' | translate"
    [size]="'default'"
    [type]="'empty'"
/>
